/* eslint-disable no-alert */
import axios from 'axios';
import _ from 'lodash';

const accessKey = 'accessToken';
const profile = 'userProfile';
const isPasswordUpdateRequired = 'changePassword';
const province = 'province';
const isSSOLogin = 'isSSOLogin';

export const environments = [
  {
    name: 'dev',
    env: 'https://dev.mysalesorders.com',
    apiHost: 'https://dh90q9pb01dyh.cloudfront.net/api',
    wlsApiHost: 'https://dq696qbf1uch1.cloudfront.net/api',
    sof1ApiHost: 'https://d19gw23pzxczol.cloudfront.net/api',
    adtApiHost: 'https://d3qv35y8tvum1q.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'qa',
    env: 'https://qa.mysalesorders.com',
    apiHost: 'https://d1meidkmedcrj5.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'qa-v2',
    env: 'https://d27bou8gmyx1e.cloudfront.net',
    apiHost: 'https://dh90q9pb01dyh.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'prod',
    env: 'https://www.mysalesorders.com',
    apiHost: ' https://d36u5buucu9rtz.cloudfront.net/api',
    sof1ApiHost: ' https://d392300n61qa5s.cloudfront.net/api',
    adtApiHost: 'https://d2mcrq783vsnc2.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'prod-mirror',
    env: 'https://d2wp13x51xrzvy.cloudfront.net',
    apiHost:
      'http://prod-sof-2.eba-vfm24qze.ca-central-1.elasticbeanstalk.com/api',
    sof1ApiHost: ' https://d392300n61qa5s.cloudfront.net/api',
    adtApiHost: 'https://d2mcrq783vsnc2.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'preview',
    env: 'https://preview.mysofportal.com',
    apiHost: ' https://d36u5buucu9rtz.cloudfront.net/api',
    sof1ApiHost: ' https://d392300n61qa5s.cloudfront.net/api',
    adtApiHost: 'https://d2mcrq783vsnc2.cloudfront.net',
    leadQueueConfig: {
      leadValue: '00G40102031FFfZEAW'
    }
  },
  {
    name: 'vulcan',
    env: 'https://qa.vulcan.mysalesorders.com',
    apiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'sow',
    env: 'https://qa.sow.mysalesorders.com',
    apiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'ocdr',
    env: 'https://qa.ocdr.mysalesorders.com',
    apiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'cybersecurity',
    env: 'https://qa.cybersecurity.mysalesorders.com',
    apiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'product-catalog',
    env: 'https://qa.productcatalog.mysalesorders.com',
    apiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'dev-platform-consolidation',
    env: 'https://d39z5y8ixwzjbl.cloudfront.net',
    apiHost: 'https://d3lvpnl565ely2.cloudfront.net/api',
    wlsApiHost: 'https://dq696qbf1uch1.cloudfront.net/api',
    sof1ApiHost: 'https://d19gw23pzxczol.cloudfront.net/api',
    adtApiHost: 'https://d3qv35y8tvum1q.cloudfront.net',
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  }
];

export const getEnvironment = () => {
  const currentEnvironment = environments.find(
    environment => window.location.origin === environment.env
  );
  return currentEnvironment || environments[0];
};

const getApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.apiHost;
};

const getWlsApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.apiHost;
};

const getSOF1ApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.sof1ApiHost;
};

const getAdtDashboardApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.adtApiHost;
};

export const apiHost = getApiHost();
export const wlsHost = getWlsApiHost();
export const sof1ApiHost = getSOF1ApiHost();
export const adtApiHost = getAdtDashboardApiHost();

export const config = (options = {}) => {
  return {
    ...options,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(accessKey)}`,
      'Access-Control-Allow-Origin': '*',
      ...options.headers
    }
  };
};

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const {
      response: {
        data: { message },
        status
      }
    } = error || {};

    if (status === 403) {
      localStorage.setItem('isExpired', 'true');
      // Clear token expiry time as well
      localStorage.removeItem('tokenExpiry');
    } else {
      throw error;
    }

    return {
      status,
      message
    };
  }
);

const request = {
  setToken: token => {
    localStorage.setItem(accessKey, token);
    // Store token expiry time (24 hours from now, matching backend token expiration)
    const tokenExpiry = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem('tokenExpiry', tokenExpiry.toString());
    // Warm the Contentful connection config now that the session exists (lazy import: contentful.js depends on this module).
    import('../contentful').then(({ prefetchCfConfig }) => prefetchCfConfig());
  },
  setProfile: value => {
    const data = {
      ...value,
      name: `${value.firstName} ${value.lastName}`
    };
    localStorage.setItem(profile, JSON.stringify(data));
  },
  setPasswordUpdate: value => {
    localStorage.setItem(isPasswordUpdateRequired, value);
  },
  setSSOLoginState: value => {
    localStorage.setItem(isSSOLogin, value);
  },
  getToken: () => {
    return localStorage.getItem(accessKey);
  },
  getProfile: () => {
    return JSON.parse(localStorage.getItem(profile));
  },
  getProvince: () => {
    return localStorage.getItem(province);
  },
  getPasswordUpdate: () => {
    return JSON.parse(localStorage.getItem(isPasswordUpdateRequired));
  },
  getSSOLoginState: () => {
    const data = localStorage.getItem(isSSOLogin);
    return data ? JSON.parse(data) : false;
  },
  get: (url, options) => {
    return axios.get(`${apiHost}${url}`, config(options));
  },
  post: (url, body, options) => {
    return axios.post(`${apiHost}${url}`, body, config(options));
  },
  put: (url, body, options) => {
    return axios.put(`${apiHost}${url}`, body, config(options));
  },
  delete: url => {
    return axios.delete(`${apiHost}${url}`, config());
  }
};

const role = _.get(request.getProfile(), 'role.name', '');
export const isAdmin = role === 'ADMIN';
export const isOrderFulfillmentTeam = role === 'ORDER_FULFILLMENT';

// Reports module (see components/blackFridayReports): these roles see server-side
// role-scoped data (their own/assigned orders only, and PDFs/emails tied to those orders —
// see sof2_portal_backend's services/reports/reportScope.js), so their report totals won't
// match what an ADMIN sees for the same date range. Used to show an explanatory UI note.
// Reads the profile live on every call (unlike isAdmin/isOrderFulfillmentTeam above, which
// are fixed at module import) so it stays correct if the profile changes mid-session.
export const SCOPED_REPORTS_ROLES = ['SALES_MANAGER', 'ORDER_FULFILLMENT', 'SALES_SUPPORT'];
export const isScopedReportsRole = () => {
  const liveRole = _.get(request.getProfile(), 'role.name', '');
  return SCOPED_REPORTS_ROLES.includes(liveRole);
};

// Returns true when the current user is a Sales Manager without
// `canSubmitOrders`. Such users have read-only access to OFD/MyOrders
// dashboards: they can view orders but must not see Continue / Modify /
// Cancel mutation buttons in the row Actions column.
export const isSmReadOnly = () => {
  const userProfile = request.getProfile() || {};
  const roleName = _.get(userProfile, 'role.name', '');
  return roleName === 'SALES_MANAGER' && !userProfile.canSubmitOrders;
};

export const USER_RIGHTS = {
  ADMIN: {
    isStatusEditable: true,
    isUserEditable: true,
    canAssignOrder: true,
    isAdminBandVisible: true,
    isUserPageVisible: true,
    isSOVDashboardVisible: true,
    isBulkUploadVisible: true,
    isHardwareGridUploadVisible: true,
    isHomeLinkVisible: true,
    isProductCatalogVisible: true,
    isAutomationVisible: true,
    isBlackFridayReportsVisible: true
  },
  ORDER_FULFILLMENT: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  PROPOSAL_HOUSE: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  SOV_AGENT: {
    isStatusEditable: true,
    isUserEditable: false,
    canAssignOrder: true,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: false
  },
  SOV_ADMIN: {
    isStatusEditable: true,
    isUserEditable: false,
    canAssignOrder: true,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: false
  },
  SRT_GROUP: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  PRODUCT_TEAM: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: false
  },
  SALES_REP: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  TELUS_MANAGER: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  SALES_MANAGER: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  SALES_SUPPORT: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  TECH: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  ADT_RETENTION: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  CBM: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  EPP: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  }
};

export default request;
